import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { Text, Flex, Label, Content, Button } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { TitleBar } from '@leverege/ui-plugin';
import { LoadingScreen } from '@leverege/molten/screens';
import DeviceInput from '../pairing/DeviceInput';
import Scan from './Scan';
import DeviceSearch from './DeviceSearch';
import S from './Pair.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function PairForm(props) {
  const {
    assetId,
    trackerId,
    asset,
    tracker,
    onChange: pOnChange,
    onPair: pOnPair,
    areaClassName,
    footerClassName,
    onClose,
    titleVariant,
    titleIcon,
    actions
  } = props;
  const [activeScreen, setActiveScreen] = useState('main');
  const [activeField, setActiveField] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const onClick = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
    setActiveField(data.field);
  }, [setActiveScreen, setActiveField]);
  const onFocusAsset = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
    setActiveField(data.field);
  });
  const onFocusTracker = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
    setActiveField(data.field);
  });
  const onChange = useCallback(evt => {
    setActiveScreen('main');
    setActiveField(null);
    pOnChange(evt);
  }, [pOnChange]);
  const onPair = useCallback(async evt => {
    setLoading(true);
    try {
      await pOnPair();
      setActiveScreen('pairSuccess');
    } catch (err) {
      setError(err);
      setActiveScreen('pairFail');
    }
    setTimeout(() => setLoading(false), 250);
  }, [pOnPair]);
  const getSearchText = useCallback(selected => {
    if (activeField === 'trackerId') {
      return selected?.data?.macAddress;
    }
    return selected?.data?.name;
  }, [activeField]);
  const goTo = useCallback(({
    data
  }) => {
    let action;
    if (data === 'asset') {
      action = actions.goTo(asset.id);
    } else {
      action = actions.parent().child('beacons').goTo(`${tracker.id}`);
    }
    GlobalState.dispatch(action);
    onClose();
  }, [asset, tracker, actions]);
  if (loading) {
    return /*#__PURE__*/_jsx(Content, {
      variant: "pairingContent|rootEditor",
      children: /*#__PURE__*/_jsx(Content.Area, {
        variant: "formBody",
        className: classnames(S.loadingArea, areaClassName),
        children: /*#__PURE__*/_jsx(LoadingScreen, {
          title: "Pairing"
        })
      })
    });
  }
  let header;
  let content;
  let footer;
  let body = null;
  switch (activeScreen) {
    case 'scan':
      content = /*#__PURE__*/_jsx(Scan, {
        ...props,
        eventData: activeField,
        onClick: onClick,
        onChange: onChange
      });
      break;
    case 'search':
      {
        const {
          [activeField]: val
        } = props;
        body = /*#__PURE__*/_jsx(DeviceSearch, {
          ...props,
          eventData: activeField,
          value: val,
          onChange: onChange,
          onClick: onClick,
          getSearchText: getSearchText
        });
        break;
      }
    case 'pairSuccess':
      {
        header = /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: "Successfully Paired",
          icon: titleIcon
        });
        content = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("img", {
            className: S.successImage,
            width: 120,
            height: 120,
            alt: "successfully paired",
            src: "https://recovr-ui-assets.storage.googleapis.com/pair-success.png"
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colXL",
            align: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: "Success"
            }), /*#__PURE__*/_jsx(ErrorMessage, {
              trackerId: trackerId,
              assetId: assetId,
              error: error
            }), /*#__PURE__*/_jsxs("div", {
              className: S.buttonContainer,
              children: [/*#__PURE__*/_jsx(Button, {
                variant: "fakeList",
                eventData: "tracker",
                onClick: goTo,
                children: trackerId
              }), /*#__PURE__*/_jsx(Button, {
                variant: "fakeList",
                eventData: "asset",
                onClick: goTo,
                children: assetId
              })]
            })]
          })]
        });
        footer = /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            onClick: onClose,
            children: "Done"
          })
        });
        break;
      }
    case 'pairFail':
      {
        header = /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: "Failed to Pair",
          icon: titleIcon
        });
        content = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("img", {
            className: S.successImage,
            width: 120,
            height: 120,
            alt: "failed to pair",
            src: "https://recovr-ui-assets.storage.googleapis.com/pair-failure.png"
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colXL",
            align: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: "Failure"
            }), /*#__PURE__*/_jsx(ErrorMessage, {
              trackerId: trackerId,
              assetId: assetId,
              error: error
            })]
          })]
        });
        footer = /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: onClose,
            variant: "secondary",
            children: "Cancel"
          }), /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            disabled: !assetId || !trackerId || loading,
            onClick: onPair,
            children: "Try Again"
          })]
        });
        break;
      }
    default:
      header = /*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Pair Beacon to Zone",
        icon: titleIcon
      });
      content = /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "bodySmall",
          children: "Choose which zone and beacon you'd like to pair."
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Beacon ID"
        }), /*#__PURE__*/_jsx(DeviceInput, {
          hint: "Search Beacon",
          eventData: "trackerId",
          value: trackerId,
          onChange: onChange,
          onFocus: onFocusTracker,
          onClick: onClick
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Zone"
        }), /*#__PURE__*/_jsx(DeviceInput, {
          hint: "Search Zone",
          eventData: "assetId",
          value: assetId,
          onChange: onChange,
          onFocus: onFocusAsset,
          onClick: onClick,
          scanEnabled: false
        })]
      });
      footer = /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          variant: "secondary",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          disabled: !assetId || !trackerId || loading,
          onClick: onPair,
          children: "Pair"
        })]
      });
  }
  return /*#__PURE__*/_jsxs(Content, {
    variant: "pairingContent|rootEditor",
    children: [header && /*#__PURE__*/_jsxs(Content.Header, {
      variant: "formHeader",
      children: [header, /*#__PURE__*/_jsx(Button, {
        variant: "closeDialog",
        className: S.close,
        onClick: onClose
      })]
    }), content && /*#__PURE__*/_jsx(Content.Area, {
      variant: "formBody",
      className: areaClassName,
      style: {
        overflow: 'unset'
      },
      children: content
    }), footer && /*#__PURE__*/_jsx(Content.Footer, {
      variant: "formButtons",
      className: classnames(S.footer, footerClassName),
      layout: "flex:rowMEnd",
      children: footer
    }), body]
  });
}
function ErrorMessage(props) {
  const {
    error,
    trackerId,
    assetId
  } = props;
  if (!error) {
    return null;
  }
  if (error.status === 400) {
    return /*#__PURE__*/_jsxs(Text, {
      children: ["Beacon ", /*#__PURE__*/_jsx("b", {
        children: trackerId
      }), " was unable to pair with Zone ", /*#__PURE__*/_jsx("b", {
        children: assetId
      }), ". Please unpair the Beacon from any other Zones and try again."]
    });
  }
  return /*#__PURE__*/_jsxs(Text, {
    children: ["Beacon ", /*#__PURE__*/_jsx("b", {
      children: trackerId
    }), " was unable to pair with Zone ", /*#__PURE__*/_jsx("b", {
      children: assetId
    }), " because of a network connection failure"]
  });
}